<template>
    <v-app>

        <flash-message></flash-message>

        <!-- Router view rendered here -->
        <v-main>
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </v-main>

    </v-app>
</template>

<script>
    import FlashMessage from "@/components/application/FlashMessage.vue";

    export default {
        components: {
            FlashMessage
        },

        created() {
          const loader = document.getElementById('ninja-loader');

          if (loader) {
            loader.remove();
          } else {
            console.log("Ninja loader not found!");
          }
        }
    }

</script>


